import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { DateRangeSelector } from 'src/core/POS/DateRangeSelector';
import { ContentId } from 'src/utils/constants/contentId';
import {
  getDisabledDatesForTimeFrameFilter,
  StandardDateRangePresetNames,
  StandardDateRangePresetNamesV2,
} from 'src/utils/dateTimeUtils';
import {
  DateTimeRangeWithRelative,
  EventTimeFrameFilter,
  FilterOperationType,
} from 'src/WebApiController';

export type EventLastReviewedFilter = {
  eventNotReviewedSinceDate: DateTimeRangeWithRelative | null;
  eventTimeFrameFilter: EventTimeFrameFilter | null;

  operations?: {
    eventNotReviewedSinceDateOp?: FilterOperationType | null;
  } | null;
};

export const useEventLastReviewedFilters = <
  TFilter extends EventLastReviewedFilter,
>({
  initialQuery,
  tempQuery,
  setTempQuery,
  supportMultiOperation = false,
  isHorizontalLayout = false,
}: {
  initialQuery: TFilter;
  tempQuery: TFilter;
  setTempQuery: (query: TFilter) => void;
  supportMultiOperation?: boolean;
  isHorizontalLayout?: boolean;
}): FilterToolbarItem[] => {
  return [
    {
      filterId: 'eventNotReviewedSinceDate' as FilterToolbarItemId,
      labelContentId: ContentId.EventNotReviewedSince,
      filterQueryKeys: ['eventNotReviewedSinceDate'] as FilterToolbarItemId[],
      filterItem: (
        <DateRangeSelector
          useRelativePresets={false}
          presetNames={StandardDateRangePresetNames}
          exactPresetNames={StandardDateRangePresetNamesV2}
          trailingPresetNames={StandardDateRangePresetNamesV2}
          value={tempQuery.eventNotReviewedSinceDate}
          defaultValue={initialQuery.eventNotReviewedSinceDate}
          operation={tempQuery.operations?.eventNotReviewedSinceDateOp ?? null}
          enableOperationSelect={supportMultiOperation}
          isHorizontalLayout={isHorizontalLayout}
          onBlur={({ value, operation }) =>
            setTempQuery({
              ...tempQuery,
              eventNotReviewedSinceDate: value,
              operations: supportMultiOperation
                ? {
                    ...tempQuery.operations,
                    eventNotReviewedSinceDateOp: operation,
                  }
                : undefined,
            })
          }
          disabledDay={(d) =>
            getDisabledDatesForTimeFrameFilter(
              d,
              tempQuery.eventTimeFrameFilter
            )
          }
        />
      ),
    },
  ];
};
